import { Typography } from '@mui/material';
import theme, {
  TMaterialStyleItem,
  TMaterialStyles,
  TShadow,
} from '../../theme';
import React from 'react';

interface ITypographyWithShadow extends React.PropsWithChildren {
  sx?: TMaterialStyleItem;
  shadowType?: TShadow;
}

const TypographyWithShadow: React.FC<ITypographyWithShadow> = ({
  children,
  sx,
  shadowType = 'LIGHT',
}) => {
  return (
    <Typography
      sx={[
        shadowType === 'LIGHT' ? materialStyles.text : null,
        shadowType === 'DARK' ? materialStyles.darkText : null,
        shadowType === 'GOLD' ? materialStyles.goldText : null,
        shadowType === 'SILVER' ? materialStyles.silverText : null,
        shadowType === 'BRONZE' ? materialStyles.bronzeText : null,
        shadowType === 'ERROR' ? materialStyles.errorText : null,
        shadowType === 'SUCCESS' ? materialStyles.successText : null,
        shadowType === 'MORE_DARK' ? materialStyles.moreDarkText : null,
        sx || null,
      ]}
    >
      {children}
    </Typography>
  );
};

const materialStyles: TMaterialStyles = {
  text: {
    color: theme.palette.text.primary,
    textShadow: `0px 1.5px 0px ${theme.palette.primary.main}`,
  },
  darkText: {
    color: theme.palette.text.primary,
    textShadow: `0px 2px 0px ${theme.palette.secondary.main}`,
  },
  goldText: {
    textShadow: `0px 2px 0px ${theme.palette.gold.shadow}`,
  },
  silverText: {
    textShadow: `0px 2px 0px ${theme.palette.silver.shadow}`,
  },
  bronzeText: {
    textShadow: `0px 2px 0px ${theme.palette.bronze.shadow}`,
  },
  errorText: {
    textShadow: `0px 2px 0px ${theme.palette.error.dark}`,
  },
  successText: {
    textShadow: `0px 2px 0px ${theme.palette.success.contrastText}`,
  },
  moreDarkText: {
    textShadow: `0px 2px 0px ${theme.palette.grey[900]}`,
  },
};

export default TypographyWithShadow;
